
function Footer() {
    return <div className="footer">
        <div className="reseauxDiv">
            <p>Nos réseaux</p>
            <div className="reseaux">
                <a href="https://bsky.app/profile/moneyforflowers.bsky.social" target="_blank" rel="noreferrer"><img src="blueskyBlack.png" alt="Bluesky"/></a>
                <a href="https://www.instagram.com/money.for.flowers" target="_blank" rel="noreferrer"><img src="instaBlack.png" alt="Instagram"/></a>
                <a href="https://twitter.com/MoneyForFlowers" target="_blank" rel="noreferrer"><img src="twitterBlack.png" alt="Twitter"/></a>
            </div>
        </div>

    </div>;
}

export default Footer;